import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle, XCircle } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords don't match");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    setBusy(true);
    try {
      await api.post("/api/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password reset — please sign in.");
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-white border border-[#E5E7EB] rounded-2xl p-8" data-testid="reset-password-page">
        {!token ? (
          <>
            <XCircle className="w-12 h-12 mx-auto text-[#D92D20]" />
            <h1 className="font-display font-black text-2xl text-center mt-3">Invalid reset link</h1>
            <p className="text-sm text-[#4B5563] text-center mt-2">The link is missing or invalid. Please request a new one.</p>
            <Link to="/forgot-password" className="btn-primary w-full mt-6 inline-block text-center">Request new link</Link>
          </>
        ) : done ? (
          <>
            <CheckCircle className="w-12 h-12 mx-auto text-[#064E3B]" />
            <h1 className="font-display font-black text-2xl text-center mt-3">Password updated</h1>
            <p className="text-sm text-[#4B5563] text-center mt-2">Redirecting you to sign in…</p>
          </>
        ) : (
          <>
            <div className="label-eyebrow">Choose a new password</div>
            <h1 className="font-display font-black text-3xl mt-2">Set new password</h1>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm font-semibold">New password</label>
                <input data-testid="reset-pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
                  className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
              </div>
              <div>
                <label className="text-sm font-semibold">Confirm new password</label>
                <input data-testid="reset-pw2" type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)}
                  className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
              </div>
              <button data-testid="reset-submit" type="submit" disabled={busy} className="btn-primary w-full">
                {busy ? "Updating..." : "Update password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
